import * as z from "zod";

export const syncDeliveryProfileProductMetafieldsNow = {
  name: "syncDeliveryProfileProductMetafieldsNow" as const,
  input: z.object({ teamId: z.string() }),
  output: z.null(),
};
